import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import {
  selectResetPasswordError,
  selectResetPasswordSucceed,
} from '../../../redux/auth/selectors';
import * as resetPassword from '../../../redux/auth/reset-password';
import {
  selectPrimaryContactsEnabled,
  selectPublicConstantsSending,
} from '../../../redux/data/selectors';
import { actions as publicConstantsActions } from '../../../redux/data/publicConstants';

const mapStateToProps = state => ({
  succeed: selectResetPasswordSucceed(state),
  errors: selectResetPasswordError(state),
  primaryContactsEnabled: selectPrimaryContactsEnabled(state),
  publicConstantsLoading: selectPublicConstantsSending(state),
});

const mapDispatchToProps = {
  resetPassword: resetPassword.actions.send,
  fetchPublicConstants: publicConstantsActions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/Auth/RecoverPassword/enhance.js